// Explicit currency prefixes so a Canadian never wonders whether "$99.50" is USD.
const PREFIX = { cad: 'CA$', usd: 'US$', inr: '₹', eur: '€', gbp: '£', aud: 'A$', nzd: 'NZ$' };

export function fmtMoney(minor, currency = 'cad', divisor = 100) {
  const cur = String(currency || 'cad').toLowerCase();
  const prefix = PREFIX[cur] ?? `${cur.toUpperCase()} `;
  const value = (Number(minor) || 0) / (Number(divisor) || 100);
  return `${prefix}${value.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const currencyCode = (c) => String(c || 'cad').toUpperCase();
